'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubtitleContainer = undefined;

var _Style = require('./Style');

var _Style2 = _interopRequireDefault(_Style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubtitleContainer = function SubtitleContainer(refs) {
    var i18n = refs.i18nManager.get();

    var container = Ext.create('Ext.container.Container', {
        layout: 'column',
        bodyStyle: 'border:0 none; padding-bottom:1px'
    });

    container.hideSubtitleCheckbox = Ext.create('Ext.form.field.Checkbox', {
        boxLabel: i18n.hide_chart_subtitle,
        style: 'margin-bottom:' + _Style2.default.checkboxBottomMargin + 'px; margin-right:5px',
        width: 125,
        listeners: {
            change: function change() {
                container.subtitleInput.xable();
            }
        }
    });

    container.subtitleInput = Ext.create('Ext.form.field.Text', {
        width: _Style2.default.cmpWidth - _Style2.default.labelWidth - 5,
        emptyText: i18n.chart_subtitle,
        maxLength: 100,
        enforceMaxLength: true,
        style: 'margin-bottom:0',
        xable: function xable() {
            this.setDisabled(container.hideSubtitleCheckbox.getValue());
        }
    });

    container.add([container.hideSubtitleCheckbox, container.subtitleInput]);

    return container;
};

exports.SubtitleContainer = SubtitleContainer;
exports.default = SubtitleContainer;
//# sourceMappingURL=Subtitle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/options/Subtitle.js
 ** module id = 361
 ** module chunks = 0
 **/